import Layout from '@/layouts/Layout'

const cars = {
  path: '/vehicle',
  component: Layout,
  name: 'vehicle',
  meta: {
    title: '车辆',
    icon: 'user-menu',
  },
  children: [
    {
      path: '/vehicle/groupDashboard/list',
      name: 'car_data_board_tenant',
      component: () => import('@/pages/cars/carDashboard/group/list'),
      meta: { title: '车辆数据看板（集团）', logEvent: '' },
    },
    {
      path: '/vehicle/companyDashboard/list',
      name: 'car_data_board_company',
      component: () => import('@/pages/cars/carDashboard/company/list'),
      meta: { title: '车辆数据看板（公司）', logEvent: '' },
    },
    {
      path: '/vehicle/vehicleManage/list',
      name: 'vehicle_manage',
      component: () => import('@/pages/cars/list'),
      meta: { title: '车辆管理', logEvent: '', keepAlive: false },
    },
    {
      path: '/vehicle/vehicleManage/add',
      name: 'vehicle_list_create',
      component: () => import('@/pages/cars/vehicleManage/add'),
      meta: {
        title: '新增车辆',
        parent: {
          path: '/vehicle/vehicleManage/list',
          name: 'vehicle_manage',
          title: '车辆管理',
        },
      },
      hidden: true,
    },
    {
      path: '/vehicle/vehicleManage/edit',
      name: 'vehicle_list_edit',
      component: () => import('@/pages/cars/vehicleManage/add'),
      meta: {
        title: '编辑车辆',
        keepAlive: true,
        parent: {
          path: '/vehicle/vehicleManage/list',
          name: 'vehicle_manage',
          title: '车辆管理',
        },
      },
      hidden: true,
    },
    {
      noPermission: true,
      path: '/vehicle/vehicleManage/allEdit',
      name: 'vehicle_list_all_info_edit',
      component: () => import('@/pages/cars/vehicleManage/add/allCarInfoEdit'),
      meta: {
        title: '编辑车辆所有信息',
        keepAlive: true,
        parent: {
          path: '/vehicle/vehicleNotSent/list',
          name: 'vehicle_not_sent_car_info_list',
          title: '不可发车辆列表',
        },
      },
      hidden: true,
    },
    {
      path: '/vehicle/outInStorage/edit/outCar',
      name: 'vehicle_list_dispatch_car',
      component: () => import('@/pages/cars/outInStorage/edit/outCar.vue'),
      meta: {
        title: '发车出库',
        logEvent: '',
        parent: {
          path: '/vehicle/outInStorage/list',
          name: 'vehicle_stock',
          title: '出入库管理',
        },
      },
      hidden: true,
    },
    {
      path: '/vehicle/outInStorage/list',
      name: 'vehicle_stock',
      component: () => import('@/pages/cars/outInStorage/list/index'),
      meta: { title: '出入库管理' },
    },
    {
      path: '/vehicle/outInStorage/edit',
      name: 'vehicle_stock_edit',
      component: () => import('@/pages/cars/outInStorage/edit/index'),
      meta: {
        title: '编辑出入库记录',
        logEvent: '',
        parent: {
          path: '/vehicle/outInStorage/list',
          name: 'vehicle_stock',
          title: '出入库管理',
        },
      },
      hidden: true,
    },
    {
      path: '/vehicle/outInStorage/detail',
      name: 'vehicle_stock_detail',
      component: () => import('@/pages/cars/outInStorage/detail/index'),
      meta: { title: '出入库记录详情', logEvent: '' },
      hidden: true,
    },
    {
      path: '/vehicle/vehicleManage/detail',
      name: 'vehicle_list_detail',
      component: () => import('@/pages/cars/vehicleManage/detail/index'),
      meta: { title: '车辆详情', logEvent: '', keepAlive: false },
      hidden: true,
    },
    {
      path: '/vehicle/violation/list',
      name: 'vehicle_violation_manage',
      component: () => import('@/pages/carsService/violation/list'),
      meta: { title: '违章管理', logEvent: '' },
    },
    {
      path: '/vehicle/violation/record',
      name: 'vehicle_violation_record',
      component: () => import('@/pages/carsService/violation/list/record.vue'),
      meta: { title: '违章记录', logEvent: '' },
    },
    {
      path: '/vehicle/violation/account',
      name: 'vehicle_violation_account',
      component: () => import('@/pages/carsService/violation/account/list.vue'),
      meta: { title: '违章账号管理', logEvent: '' },
    },
    {
      path: '/vehicle/violation/queryRecord',
      name: 'vehicle_violation_query_record',
      component: () => import('@/pages/carsService/violation/account/queryRecord.vue'),
      meta: { title: '违章查询记录', logEvent: '' },
      hidden: true,
    },
    {
      path: '/vehicle/violation/guide',
      name: 'vehicle_violation_account_guide',
      component: () => import('@/pages/carsService/violation/account/guide.vue'),
      meta: { title: '违章查询操作指南', logEvent: '' },
      hidden: true,
    },
    {
      path: '/vehicle/insurance/carInsurance',
      name: 'vehicle_insurance_manage',
      component: () =>
        import('@/pages/carsService/insurance/list/carInsurance.vue'),
      meta: { title: '车险管理', logEvent: '' },
    },
    {
      path: '/vehicle/insurance/insurancePolicy',
      name: 'vehicle_insurance_policy',
      component: () =>
        import('@/pages/carsService/insurance/list/insurancePolicy.vue'),
      meta: { title: '保单管理', logEvent: '' },
    },
    {
      path: '/vehicle/maintenance/list',
      name: 'vehicle_maintenance_list_new',
      component: () => import('@/pages/carsService/maintenance/list/index'),
      meta: { title: '维保管理', logEvent: '' },
    },
    {
      path: '/vehicle/maintenance/add',
      name: 'vehicle_maintenance_list_create_new',
      component: () => import('@/pages/carsService/maintenance/add/index'),
      meta: {
        title: '新增维保管理',
        logEvent: '',
        parent: {
          path: '/vehicle/maintenance/list',
          name: 'vehicle_maintenance',
          title: '维保管理',
        },
      },
      hidden: true,
    },
    {
      path: '/vehicle/maintenance/edit',
      name: 'vehicle_maintenance_list_edit_new',
      component: () => import('@/pages/carsService/maintenance/edit/index'),
      meta: {
        title: '编辑维保',
        logEvent: '',
        parent: {
          path: '/vehicle/maintenance/list',
          name: 'vehicle_maintenance',
          title: '维保管理',
        },
      },
      hidden: true,
    },
    {
      path: '/vehicle/maintenance/detail',
      name: 'vehicle_maintenance_list_detail_new',
      component: () => import('@/pages/carsService/maintenance/detail'),
      meta: { title: '维保详情', logEvent: '' },
      hidden: true,
    },
    {
      path: '/vehicle/accident/list',
      name: 'vehicle_accident',
      component: () => import('@/pages/carsService/accident/list'),
      meta: { title: '事故管理', logEvent: '' },
    },
    {
      path: '/vehicle/accident/add',
      name: 'vehicle_accident_list_create',
      component: () => import('@/pages/carsService/accident/add'),
      meta: {
        title: '新建事故',
        logEvent: '',
        parent: {
          path: '/vehicle/accident/list',
          name: 'vehicle_accident',
          title: '事故管理',
        },
      },
    },
    {
      path: '/vehicle/accident/edit',
      name: 'vehicle_accident_list_edit',
      component: () => import('@/pages/carsService/accident/edit'),
      meta: {
        title: '编辑事故',
        logEvent: '',
        parent: {
          path: '/vehicle/accident/list',
          name: 'vehicle_accident',
          title: '事故管理',
        },
      },
    },
    {
      path: '/vehicle/accident/detail',
      name: 'vehicle_accident_list_detail',
      component: () => import('@/pages/carsService/accident/detail'),
      meta: { title: '事故详情', logEvent: '' },
    },
    {
      path: '/vehicle/carAudit/list',
      name: 'vehicle_audit',
      component: () => import('@/pages/cars/carAudit/list'),
      meta: { title: '车辆审核', logEvent: '' },
    },
    {
      path: '/vehicle/carAudit/detail',
      name: 'vehicle_audit_list_detail',
      component: () => import('@/pages/cars/carAudit/detail'),
      meta: { title: '审核详情', logEvent: '' },
    },
    {
      path: '/vehicle/carType/list',
      name: 'vehicle_config_model',
      component: () => import('@/pages/cars/vehicleConfig/carType/list'),
      meta: { title: '配置车型', logEvent: '' },
    },
    {
      path: '/vehicle/auditSwitch/list',
      name: 'vehicle_config_audit_switch',
      component: () => import('@/pages/cars/vehicleConfig/auditSwitch'),
      meta: { title: '审核开关', logEvent: '', keepAlive: false },
    },
    {
      path: '/vehicle/vehicleConfigRule/list',
      name: 'vehicle_config_rule',
      component: () => import('@/pages/cars/vehicleConfig/vehicleConfigRule'),
      meta: { title: '审核开关', logEvent: '', keepAlive: false },
    },
    {
      path: '/vehicle/licences/list',
      name: 'vehicle_licences',
      component: () => import('@/pages/cars/licences/list/index'),
      meta: { title: '车辆证照管理', logEvent: '' },
    },
    {
      path: '/vehicle/licences/add',
      name: 'vehicle_licences_list_create',
      component: () => import('@/pages/cars/licences/add/index'),
      meta: {
        title: '新增证照',

        parent: {
          path: '/vehicle/licences/list',
          name: 'vehicle_licences',
          title: '车辆证照管理',
        },
      },
      hidden: true,
    },
    {
      path: '/vehicle/licences/edit',
      name: 'vehicle_licences_list_edit',
      component: () => import('@/pages/cars/licences/edit/index'),
      meta: {
        title: '编辑证照',
        parent: {
          path: '/vehicle/licences/list',
          name: 'vehicle_licences',
          title: '车辆证照管理',
        },
      },
      hidden: true,
    },
    {
      path: '/vehicle/carRentStandard/list',
      name: 'vehicle_config_car_rent_standard',
      component: () =>
        import('@/pages/cars/vehicleConfig/carRentStandard/index'),
      meta: { title: '待租判断标准' },
    },
    {
      path: '/vehicle/newCarInStock/add',
      name: 'vehicleBatchWareHouse',
      component: () => import('@/pages/cars/newCarInStock/add'),
      meta: { title: '新车批量入库' },
    },
    {
      path: '/vehicle/vehicleTransfer/list/transferOut',
      name: 'vehicle_transfer_out_list',
      component: () =>
        import('@/pages/cars/vehicleTransfer/list/transferOut.vue'),
      meta: { title: '调出任务' },
    },
    {
      path: '/vehicle/vehicleTransfer/list/transferIn',
      name: 'vehicle_transfer_in_list',
      component: () =>
        import('@/pages/cars/vehicleTransfer/list/transferIn.vue'),
      meta: { title: '调入任务' },
    },
    {
      path: '/vehicle/vehicleTransfer/add',
      name: 'vehicle_transfer_out_list_initiate',
      component: () => import('@/pages/cars/vehicleTransfer/add/index.vue'),
      meta: {
        title: '发起调拨任务',
        parent: {
          path: '/vehicle/vehicleTransfer/list/transferOut',
          name: 'vehicle_transfer_out_list',
          title: '调出任务',
        },
      },
    },
    {
      path: '/vehicle/vehicleTransfer/edit',
      name: 'vehicle_transfer_out_list_update',
      component: () => import('@/pages/cars/vehicleTransfer/edit/index.vue'),
      meta: {
        title: '编辑调拨任务',
        parent: {
          path: '/vehicle/vehicleTransfer/list/transferOut',
          name: 'vehicle_transfer_out_list',
          title: '调出任务',
        },
      },
    },
    {
      path: '/vehicle/vehicleTransferOut/detail',
      name: 'vehicle_transfer_out_list_detail',
      component: () => import('@/pages/cars/vehicleTransfer/detail/index.vue'),
      meta: { title: '调出任务详情' },
    },
    {
      path: '/vehicle/vehicleTransferIn/detail',
      name: 'vehicle_transfer_in_list_detail',
      component: () => import('@/pages/cars/vehicleTransfer/detail/index.vue'),
      meta: { title: '调入任务详情' },
    },
    {
      path: '/vehicle/vehicleNotSent/list',
      name: 'vehicle_not_sent_car_info_list',
      component: () => import('@/pages/cars/list/cannotOutput.vue'),
      meta: { title: '不可发车辆列表' },
    },
    // 车辆运营列表
    {
      path: '/vehicle/linkage/carOperate/list',
      name: 'linkage_board_vehicle_operateList',
      component: () => import('@/pages/cars/linkage/carOperate/list'),
      meta: { title: '车辆运营列表', logEvent: '' },
    },
    // 车辆数据影响因子-网约出车情况影响因子
    {
      path: '/vehicle/linkage/workImpactFactor/detail',
      name: 'linkage_board_vehicle_workImpactFactors',
      component: () =>
        import('@/pages/cars/linkage/impactFactors/workImpactFactor/detail'),
      meta: { title: '网约出车情况影响因子', logEvent: '' },
      hidden: true,
    },
    // 车辆数据影响因子-网约运营情况影响因子
    {
      path: '/vehicle/linkage/operateImpactFactor/detail',
      name: 'linkage_board_vehicle_operateImpactFactors',
      component: () =>
        import('@/pages/cars/linkage/impactFactors/operateImpactFactor/detail'),
      meta: { title: '网约运营情况影响因子', logEvent: '' },
      hidden: true,
    },
    // 维保管理-维保项目管理
    {
      path: '/vehicle/maintenance/maintenanceProject',
      name: 'maintenanceProject',
      component: () => import('@/pages/cars/maintenanceManage/maintenanceProject/index'),
      meta: { title: '维保项目管理', logEvent: '' },
    },
    // 维保管理-详情
    {
      path: '/vehicle/maintenance/maintenanceProject_detail',
      name: 'maintenanceProject_detail',
      component: () => import('@/pages/cars/maintenanceManage/maintenanceProject/detail/index'),
      meta: { title: '维保方案详情', logEvent: '' },
    },
    // 维保管理-租赁方案绑定记录
    {
      path: '/vehicle/maintenance/leasePlan',
      name: 'leasePlan',
      component: () => import('@/pages/cars/maintenanceManage/leasePlan/index'),
      meta: { title: '租赁方案绑定记录', logEvent: '' },
    },
    // 维保管理-租赁订单绑定记录
    {
      path: '/vehicle/maintenance/leaseOrder',
      name: 'leaseOrder',
      component: () => import('@/pages/cars/maintenanceManage/leaseOrder/index'),
      meta: { title: '租赁订单绑定记录', logEvent: '' },
    },
  ],
}
export default cars
